// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2Le4C","label":"Radio_label__2vpcP","checkMark":"Radio_checkMark__3gZal","disabled":"Radio_disabled__1qxMm"};